const setToken = token => {
  localStorage.setItem("accessToken", token);
};

const clearToken = () => {
  localStorage.removeItem("accessToken");
};

const getToken = () => {
  try {
    const token = localStorage.getItem("accessToken");
    return !token ||
      token.length === 0 ||
      token === "null" ||
      token === "undefined"
      ? undefined
      : token;
  } catch (err) {
    clearToken();
    return undefined;
  }
};

const setUserId = id => {
  localStorage.setItem("userId", id);
};

const clearUserId = () => {
  localStorage.removeItem("userId");
};

const getUserId = () => {
  try {
    const userId = localStorage.getItem("userId");
    return !userId ||
      userId.length === 0 ||
      userId === "null" ||
      userId === "undefined"
      ? undefined
      : userId;
  } catch (err) {
    clearUserId();
    return undefined;
  }
};

const setLoginInfo = (token, userId) => {
  setToken(token);
  setUserId(userId);
};

const clearLoginInfo = () => {
  clearToken();
  clearUserId();
};

export default {
  setToken,
  clearToken,
  getToken,
  setUserId,
  getUserId,
  clearUserId,
  setLoginInfo,
  clearLoginInfo
};
